import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import KiAppBar from 'components/KiAppBar';
import KiTabs from 'components/KiTabs';
import KiTab from 'components/KiTabs/KiTab';
import CopyDatasetForm from './components/copyDatasetForm';
import DeleteDatasetForm from './components/deleteDatasetForm';
import EncumbranceRollbackForm from './components/encumbranceRollbackForm';
import {showSnackbar} from 'state/actions/Snackbar';
import {fetchDatasetList} from 'containers/datasetList/actions';
import './index.scss';
import DatasetHiddenSnapshotsForm from './components/datasetHiddenSnapshotsForm';
//import EncumbranceCheckpointApi from '../../api/encumbranceCheckpointApi';

const DatasetUtilities = props => {
	useEffect(() => {
		document.title = `${props.app.kiVersion} - Dataset Utilities`;
		if (props.datasets?.length === 0) {
			props.fetchDatasetList();
		}
	}, []);

	return (
		<div className="container-wrapper">
			<div className="container-body">
				<header>
					<KiAppBar className="top-bar">
						<div className="top-bar-breadcrumb">
							<h1>Dataset Utilities</h1>
						</div>
					</KiAppBar>
				</header>
				<div className="ki-panel">
					<KiTabs onChange={() => void 0} index={0}>
						<KiTab title="Dataset Copy">
							<CopyDatasetForm
								datasets={props.datasets}
								showSnackbar={props.showSnackbar}
								fetchDatasetList={props.fetchDatasetList}
							/>
						</KiTab>
						<KiTab title="Dataset Delete">
							<DeleteDatasetForm
								datasets={props.datasets}
								showSnackbar={props.showSnackbar}
								fetchDatasetList={props.fetchDatasetList}
							/>
						</KiTab>
						{window.LEDGER_ENABLED != 'true' && (
							<KiTab title="Encumbrance Undo">
								<EncumbranceRollbackForm
									datasets={props.datasets}
									showSnackbar={props.showSnackbar}
									fetchDatasetList={props.fetchDatasetList}
								/>
							</KiTab>
						)}
						{window.LEDGER_ENABLED != 'true' && (
							<KiTab title="Snapshot Reprocess">
								<DatasetHiddenSnapshotsForm
									datasets={props.datasets}
									showSnackbar={props.showSnackbar}
									fetchDatasetList={props.fetchDatasetList}
								/>
							</KiTab>
						)}
					</KiTabs>
				</div>
			</div>
		</div>
	);
};

DatasetUtilities.propTypes = {
	datasets: PropTypes.array.isRequired,
	app: PropTypes.object.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	fetchDatasetList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
	datasets: state.datasetList.data,
	app: state.app,
});

const mapDispatchToProps = () => ({
	fetchDatasetList,
	showSnackbar,
});

export default connect(
	mapStateToProps,
	mapDispatchToProps()
)(DatasetUtilities);
